var map = {
	"./HuaweiY6.png": "83d8",
	"./HuaweiY7.png": "f23a",
	"./MotorolaG10.png": "cf40",
	"./MotorolaG20.png": "9cd8",
	"./MotorolaG30.png": "8f9c",
	"./SamsungA10.png": "1717",
	"./SamsungA20.png": "c54b",
	"./SamsungA30.png": "93fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";